/**
 * 统计数据配置服务
 */

import { httpClient } from './httpClient';

export interface StatisticsConfig {
  id?: number;
  category: string;
  displayName: string; // 现在存储key_name，通过数据字典映射显示中文名称
  description?: string;
  dataType: string;
  unit?: string;
  sortOrder: number;
  isActive: number;
  createTime?: string;
  createUser?: string;
  updateTime?: string;
  updateUser?: string;
  deleted?: number;
}

export const statisticsConfigService = {
  // 获取启用的统计数据配置
  async getActiveConfigs() {
    return httpClient.get('/api/biz/platform/statistics/config');
  },

  // 根据分类获取统计数据配置
  async getConfigsByCategory(category: string) {
    return httpClient.get(`/api/biz/platform/statistics/config/category/${category}`);
  },

  // 获取统计数据配置树形结构
  async getConfigTree() {
    return httpClient.get('/api/biz/platform/statistics/config');
  },

  // 获取统计数据配置列表
  async getConfigList(params: {
    current?: number;
    size?: number;
    category?: string;
    keyword?: string;
  }) {
    return httpClient.get('/api/biz/platform/statistics/config', { params });
  },

  // 创建统计数据配置
  async createConfig(config: StatisticsConfig) {
    return httpClient.post('/api/biz/platform/statistics/config', config);
  },

  // 更新统计数据配置
  async updateConfig(id: number, config: StatisticsConfig) {
    return httpClient.put('/api/biz/platform/statistics/config', config);
  },

  // 删除统计数据配置
  async deleteConfig(id: number) {
    return httpClient.delete(`/api/biz/platform/statistics/config/${id}`);
  },

  // 批量删除统计数据配置
  async batchDeleteConfigs(ids: number[]) {
    return httpClient.delete('/api/biz/platform/statistics/config/batch', { data: ids });
  },

  // 批量更新统计数据配置
  async batchUpdateConfigs(configs: StatisticsConfig[]) {
    return httpClient.put('/api/biz/platform/statistics/config/batch', configs);
  }
};

export default statisticsConfigService;